import { toast } from 'react-toastify';

const notify = (
  message: string,
  type: 'info' | 'success' | 'warning' | 'error'
) => toast(message, { type });

export { notify };
